import React from "react";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/Hero";

import HeroImage from "../../assets/images/hero-fruit.jpg";

import AccessoriesImage from "../../assets/images/accessories.jpg";

import "./accessories.css";

function Accessories() {
  return (
    <div>
      <Header />

      <div>
        <HeroSection
          backgroundImage={HeroImage}
          title="Slushy Syrups & Accessories"
          subtitle=" Syrups, Cups, and Lids for Every Need"
          dividerPath="M0,128L48,117.3C96,107,192,85,288,117.3C384,149,480,235,576,272C672,309,768,299,864,277.3C960,256,1056,224,1152,208C1248,192,1344,192,1392,192L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          dividerColour="white"
        />
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="AccessoriesContainer">
          <div className="AccessoriesContent">
            <h3>Syrups & Mixes</h3>
            <p>
              Our syrups are available in 1-litre concentrate bottles, with 12
              bottles per carton.
            </p>
            <p>
              You can mix and match any combination of flavours or order full
              cartons of a single flavour.
            </p>
          </div>
          <div className="AccessoriesContent">
            <h3>Cups & Lids</h3>
            <p>
              Our cups come in cartons of 1000, with each sleeve containing 50.
            </p>
            <p>
              Our lids are supplied in cartons of 1000, with each sleeve
              containing 100.
            </p>
            <p>
              Additionally, we offer Eco-friendly options including
              bio-degradable and compostable cups and lids. These can be
              supplied upon request.
            </p>
          </div>
        </div>
      </div>

      <div className="AccessoriesImageContainer">
        <img alt="Accessories" src={AccessoriesImage}></img>
      </div>

      <Footer />
    </div>
  );
}

export default Accessories;
